import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { modal } from '@/share/components';

import { ref, reactive } from 'vue';
import { fetchApi } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/server/auto-import.js';
export default {
  __name: 'search-pre-partner-view',
  setup(__props, {
    expose: __expose
  }) {
    const orgList = ref([]);
    const addCount = ref(0);
    const searchFields = reactive([{
      field: 'search',
      title: '查找组织机构',
      span: 24,
      itemRender: {
        name: 'VxeInput',
        props: {
          placeholder: '机构名称、联系人或联系电话'
        }
      }
    }]);
    const {
      loading,
      runAsync: myOrgSearchPrePartnerListApi
    } = fetchApi('orgPartner.myOrgSearchPrePartnerList');
    const searchPrePartners = async search => {
      const {
        error,
        rows
      } = await myOrgSearchPrePartnerListApi({
        search
      });
      if (error) return;
      orgList.value = rows;
    };
    const columns = reactive([{
      type: 'seq',
      title: '序号',
      width: 70,
      fixed: 'left'
    }, {
      field: 'name',
      title: '组织机构名称',
      width: 240
    }, {
      field: 'contactPer',
      title: '联系人',
      width: 120
    }, {
      field: 'contactTel',
      title: '联系电话',
      width: 120
    }, {
      field: 'mobile',
      title: '手机号',
      width: 120
    }, {
      field: 'action',
      title: '操作',
      slots: {
        default: 'action'
      },
      width: 90
    }]);
    const gridOptions = reactive({
      border: true,
      headerAlign: 'center',
      align: 'left',
      rowConfig: {
        keyField: 'id',
        isCurrent: true,
        isHover: true
      },
      columnConfig: {
        resizable: true
      }
    });
    const {
      runAsync: myOrgAddPartnerApi
    } = fetchApi('orgPartner.myOrgAddPartner', {
      showError: false
    });
    const doAddPartner = async row => {
      const {
        id,
        name
      } = row || {};
      if (!id) return Promise.resolve(false);
      const {
        error
      } = await myOrgAddPartnerApi({
        partnerId: id
      });
      if (error) {
        modal.notification.error(error);
        return;
      }
      modal.notification.success(`添加${name}组织机构成功`);
      addCount.value += 1;
      return Promise.resolve(true);
    };
    const handleAddPartner = async org => {
      const res = await doAddPartner(org);
      if (!res) return;
      const rows = [...orgList.value];
      const idx = rows.findIndex(t => t.id === org.id);
      if (idx === -1) return;
      rows.splice(idx, 1);
      orgList.value = rows;
    };
    const handleDoSearchEvent = params => {
      const {
        search
      } = params;
      if (!search) return;
      searchPrePartners(search);
    };
    __expose({
      confirmListener() {
        return Promise.resolve(addCount.value);
      }
    });
    return (_ctx, _cache) => {
      const _component_vxe_button = _resolveComponent("vxe-button");
      const _component_vxe_grid = _resolveComponent("vxe-grid");
      const _component_mg_list_page_layout = _resolveComponent("mg-list-page-layout");
      return _openBlock(), _createBlock(_component_mg_list_page_layout, {
        "search-fields": _unref(searchFields),
        onSearch: handleDoSearchEvent
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_grid, _mergeProps({
          columns: _unref(columns),
          loading: _unref(loading),
          data: _unref(orgList)
        }, _unref(gridOptions)), {
          action: _withCtx(({
            row
          }) => [_createVNode(_component_vxe_button, {
            onClick: () => handleAddPartner(row)
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("添加", -1)]))]),
            _: 1
          }, 8, ["onClick"])]),
          _: 1
        }, 16, ["columns", "loading", "data"])]),
        _: 1
      }, 8, ["search-fields"]);
    };
  }
};